/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Col, Row, Image } from "antd";
import Itineries from "../../assets/images/benefits/customized-itineries.png";
import "./index.css";
import useMedia from "use-media-antd-query";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { ArrowRight } from "@mui/icons-material";
import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router";
import { loadHolidaysList } from "../../store/dashboard/actions";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const HolidaPackages = () => {
  const media = useMedia();

  const dispatch = useDispatch();
  // const history = useHistory();

  //store integrations
  const paramsDomestic = "?category=domestic";
  const paramsInternational = "?category=international";
  useEffect(() => {
    dispatch(loadHolidaysList(paramsDomestic));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { holidays_list = [] } = useSelector((state) => state.Dashboard);
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const slides =
    holidays_list !== undefined &&
    holidays_list.length !== 0 &&
    holidays_list.queryResult &&
    holidays_list.queryResult.length > 0
      ? holidays_list.queryResult.map((image) => {
          return {
            daysAndNights: image.daysAndNights,
            destinationId: image.mainDestinationId,
            startingPrice: image.lowestPrice,
            title: image.mainDestinationName,
            imageUrl: image.thumnailImages,
            packageName: image.packageName,
            _id: image.packageId,
          };
        })
      : [];

  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    centerPadding: "3px",
    slidesToShow:
      media == "xxl" && slides && slides.length >= 6
        ? 6
        : windowDimensions.width >= 1600 && slides && slides.length >= 3
        ? slides.length
        : media == "xxl" && slides && slides.length < 4
        ? slides.length
        : media == "xl" && slides && slides.length >= 5
        ? 5
        : media == "xl" && slides && slides.length < 4
        ? slides.length
        : media == "lg" && slides && slides.length >= 4
        ? 4
        : media == "lg" && slides && slides.length < 4
        ? slides.length
        : media == "md" && slides && slides.length >= 3
        ? 3
        : media == "md" && slides && slides.length < 4
        ? slides.length
        : media == "sm" && slides && slides.length >= 3
        ? 2
        : media == "sm" && slides && slides.length < 4
        ? slides.length
        : 1,
    nextArrow: <SampleNextArrow marginTop="-10px" marginRight="14px" />,
    prevArrow: <SamplePrevArrow marginTop="-10px" marginRight="14px" />,
    // fade: true,
    // speed: 1200,
    // autoplay: true,
    // autoplaySpeed: 2200,
    // slidesToScroll: 1,
  };

  // const slides = [
  //   {
  //     id: 1,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={WildLife}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Karnataka",

  //     startingPrice: "11,000 /-",
  //   },
  //   {
  //     id: 2,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={AsiaCruise}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Kerala",
  //     startingPrice: "102,000 /-",
  //   },
  //   {
  //     id: 3,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={DashboardLogo}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "West Bengal",
  //     startingPrice: "33,000 /-",
  //   },
  //   {
  //     id: 4,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Lakshadeep}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Andaman",
  //     startingPrice: "35,000 /-",
  //   },
  //   {
  //     id: 5,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Spritual}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: `Rajastan`,
  //     startingPrice: "50,000 /-",
  //   },
  // ];
  // const internationSlides = [
  //   {
  //     id: 1,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Mauritius}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Mauritius",

  //     startingPrice: "1,11,000 /-",
  //   },
  //   {
  //     id: 2,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={AsiaCruise}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Dubai",
  //     startingPrice: "102,000 /-",
  //   },
  //   {
  //     id: 3,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Bali}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Bali",
  //     startingPrice: "33,000 /-",
  //   },
  //   {
  //     id: 4,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Phuket}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: "Phuket",
  //     startingPrice: "35,000 /-",
  //   },
  //   {
  //     id: 5,
  //     content: (
  //       <Image
  //         preview={false}
  //         src={Saudi}
  //         height={250}
  //         className="border border-solid"
  //         style={{
  //           borderRadius: "25px",
  //         }}
  //         //   style={{
  //         //     opacity: 0.8,
  //         //   }}
  //         width={"100%"}
  //       />
  //     ),
  //     title: `Saudi`,
  //     startingPrice: "50,000 /-",
  //   },
  // ];

  const [holidayMode, setHolidayMode] = useState("Domestic");

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
        <Row>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
            style={{
              fontFamily: "Poppins",
            }}
          >
            <div>
              <h1
                className={
                  media == "sm" || media == "xs"
                    ? "text-[24px] font-extrabold flex flex-col"
                    : "text-[24px] font-extrabold flex"
                }
              >
                <p className="text-[#eb3a3e] mr-1">Handpicked</p>
                <p>Holiday Packages</p>
              </h1>

              <p className="text-[15px]  mt-2 font-normal text-start">
                Indulge in unforgettable adventure with special tour packages
              </p>
              {/* <h1 className="text-[20px] font-semibold">PMT New Launches</h1> */}
            </div>
          </Col>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
            style={{
              fontFamily: "Poppins",
            }}
          >
            <div className={"flex"}>
              <div>
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    holidayMode == "Domestic"
                      ? "cursor-pointer pt-2 pb-2 pl-5 pr-5 rounded-md text-[16px] border border-[#eb3a3e] hover hover:border-[#eb3a3e] hover:text-[#eb3a3e]"
                      : "cursor-pointer pt-2 pb-2 pl-5 pr-5 rounded-md text-[16px] border border-[lightgray] hover hover:border-[#eb3a3e] hover:text-[#eb3a3e]"
                  }
                  onClick={() => {
                    setHolidayMode("Domestic");
                    dispatch(loadHolidaysList(paramsDomestic));
                  }}
                >
                  Domestic
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    holidayMode == "International"
                      ? "cursor-pointer pt-2 pb-2 pl-5 pr-5 rounded-md ml-3 text-[16px] border border-[#eb3a3e] hover hover:border-[#eb3a3e] hover:text-[#eb3a3e]"
                      : "cursor-pointer pt-2 pb-2 pl-5 pr-5 rounded-md ml-3 text-[16px] border border-[lightgray] hover hover:border-[#eb3a3e] hover:text-[#eb3a3e]"
                  }
                  onClick={() => {
                    setHolidayMode("International");
                    dispatch(loadHolidaysList(paramsInternational));
                  }}
                >
                  International
                </div>
              </div>
            </div>
          </Col>
          {holidayMode === "International" ? (
            <Col
              md={24}
              sm={24}
              lg={24}
              xl={24}
              xxl={24}
              className={
                media == "sm" || media == "xs"
                  ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                  : "pt-3 pb-3 pl-[80px] pr-[80px]"
              }
            >
              <div
                style={{
                  // width: "100%",
                  marginTop: "25px",
                }}
              >
                {slides && slides.length > 0 ? (
                  <Slider
                    {...settings}
                    centerMode
                    arrows
                    // prevArrow={<ArrowLeftOutlined />}
                    // nextArrow={<ArrowRightOutlined />}
                    className="h-[100%] z-100"
                  >
                    {slides && slides.length > 0
                      ? slides.map((slide, index) => {
                          return (
                            <div key={index} className="h-[100%] pr-2 pl-2">
                              <Image
                                preview={false}
                                src={slide.imageUrl}
                                height={250}
                                className="border border-solid"
                                style={{
                                  borderRadius: "25px",
                                }}
                                width={"100%"}
                              />

                              <div
                                className={
                                  media === "xxl"
                                    ? "absolute bottom-[-18px] ml-5 mb-6 z-1000"
                                    : "absolute bottom-[-18px] ml-3 mb-6 z-1000"
                                }
                              >
                                <div
                                  style={{
                                    borderRadius: "20px",
                                  }}
                                  className="bg-[white] shadow-lg p-4"
                                >
                                  <div className="flex justify-between border border-b-1 border-x-0 border-t-0">
                                    <h1
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="text-[15px] font-semibold"
                                    >
                                      {slide.title}
                                    </h1>
                                    <Image
                                      src={Itineries}
                                      preview={false}
                                      color="white"
                                      height={30}
                                      width={30}
                                      className="text-[15px] text-[white]"
                                    />
                                  </div>
                                  <div className="flex mt-2 justify-between">
                                    <h1
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="text-[14px] flex"
                                    >
                                      From{" "}
                                      <p className="ml-1 flex text-[15px] font-semibold">
                                        ₹. {slide.startingPrice}
                                      </p>
                                    </h1>
                                    <Link
                                      to={{
                                        pathname: `/package-details/${slide.title}`,
                                        state: slide,
                                      }}
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="mt-1 ml-2 text-[#eb3a3e] text-[12px] font-semibold cursor-pointer hover:ml-[3px]"
                                    >
                                      Explore {" ->"}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </Slider>
                ) : (
                  <div
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[18px] w-[100%] flex justify-center"
                  >
                    No Packages found..
                  </div>
                )}
              </div>
            </Col>
          ) : (
            <Col
              md={24}
              sm={24}
              lg={24}
              xl={24}
              xxl={24}
              className={
                media == "sm" || media == "xs"
                  ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                  : "pt-3 pb-3 pl-[80px] pr-[80px]"
              }
            >
              <div
                style={{
                  // width: "100%",
                  marginTop: "25px",
                }}
              >
                {slides && slides.length > 0 ? (
                  <Slider
                    {...settings}
                    centerMode
                    arrows
                    // prevArrow={<ArrowLeftOutlined />}
                    // nextArrow={<ArrowRightOutlined />}
                    className="h-[100%] z-100"
                  >
                    {slides && slides.length > 0
                      ? slides.map((slide, index) => {
                          return (
                            <div key={index} className="h-[100%] pr-2 pl-2">
                              <Image
                                preview={false}
                                src={slide.imageUrl}
                                height={250}
                                className="border border-solid"
                                style={{
                                  borderRadius: "25px",
                                }}
                                width={"100%"}
                              />

                              <div className="absolute bottom-[-18px] ml-3 mb-6 z-1000">
                                <div
                                  style={{
                                    borderRadius: "20px",
                                  }}
                                  className="bg-[white] shadow-lg p-4"
                                >
                                  <div className="flex justify-between border border-b-1 border-x-0 border-t-0">
                                    <h1
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="text-[15px] font-semibold"
                                    >
                                      {slide.title}
                                    </h1>
                                    <Image
                                      src={Itineries}
                                      preview={false}
                                      color="white"
                                      height={30}
                                      width={30}
                                      className="text-[15px] text-[white]"
                                    />
                                  </div>
                                  <div className="flex mt-2 justify-between">
                                    <h1
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="text-[14px] flex"
                                    >
                                      From{" "}
                                      <p className="ml-1 flex text-[15px] font-semibold">
                                        ₹. {slide.startingPrice}
                                      </p>
                                    </h1>
                                    <Link
                                      to={{
                                        pathname: `/package-details/${slide.title}`,
                                        state: slide,
                                      }}
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="mt-1 ml-2 text-[#eb3a3e] text-[12px] font-semibold cursor-pointer hover:ml-[3px]"
                                    >
                                      Explore {" ->"}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </Slider>
                ) : (
                  <div
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[16px] w-[100%] flex justify-center"
                  >
                    No Packages found..
                  </div>
                )}
              </div>
            </Col>
          )}
        </Row>
      </Col>
    </React.Fragment>
  );
};

HolidaPackages.propTypes = {
  location: PropTypes.any,
};
export default HolidaPackages;
